import { REGEX_EMAIL } from "../../../utils/regex";

export const getPrimaryAdvertiserUser = (users) => {
  if (!Array.isArray(users)) {
    return null;
  }

  return (
    users.find((user) => user.role === "advertiser" && !user.isDeleted) || null
  );
};

export const getPrimaryAdvertiserEmail = ({
  users,
  searchMatchedEmail = null,
}) => {
  if (
    searchMatchedEmail &&
    REGEX_EMAIL.test(String(searchMatchedEmail).trim())
  ) {
    return String(searchMatchedEmail).trim();
  }

  const email = getPrimaryAdvertiserUser(users)?.email;

  if (!email || !REGEX_EMAIL.test(String(email).trim())) {
    return null;
  }

  return String(email).trim();
};

export const getAdvertiserUserSubtitle = (users, searchMatchedEmail = null) => {
  const advertiserUser = getPrimaryAdvertiserUser(users);
  const email = searchMatchedEmail || advertiserUser?.email;

  if (advertiserUser?.name && email) {
    return `${advertiserUser.name}/${email}`;
  }

  return email || advertiserUser?.name || null;
};
